import { createSceneReducer } from 'reducers/reducers-util';
import purchaseOrdersDataReducer from 'components/admin/purchase-orders/store/reducers.data';
import purchaseOrdersUiReducer from 'components/admin/purchase-orders/store/reducers.ui';

export default createSceneReducer(
  purchaseOrdersDataReducer,
  purchaseOrdersUiReducer
);
